var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: "data-enter",
    staticClass: "page__data-enter"
  }, [_c('div', {
    staticClass: "back-to-home rounded d-none d-sm-block"
  }, [_c('a', {
    staticClass: "btn btn-icon btn-soft-primary",
    attrs: {
      "href": "index.html"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "home"
    }
  })], 1)]), _c('section', {
    staticClass: "bg-home d-flex align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col px-0 px-md-2"
  }, [_vm.project.desc_img ? _c('div', {
    staticClass: "page__data-enter__image-wrapper"
  }, [_c('img', {
    staticClass: "img-fluid d-block mx-auto mt-4",
    attrs: {
      "src": _vm.helperImgPath(_vm.project.desc_img),
      "alt": _vm.project.title
    }
  })]) : _c('div', {
    staticClass: "page__data-enter__image-wrapper"
  }, [_c('img', {
    staticClass: "img-fluid d-block mx-auto mt-4",
    attrs: {
      "src": require("@/assets/images/illustrator/analyze_report_4.svg")
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v("Dobrodošli pri raziskavi ...")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  })])]), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-7"
  }, [_c('div', {
    staticClass: "card login_page shadow rounded border-0"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('UserData')], 1)])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }